"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomHistory = exports.CreateEvent = void 0;
const generateKey = () => Math.random()
    .toString(36)
    .substr(2, 6);
// IE Polyfill for CustomEvent
const CreateEvent = (windowInternal, documentInternal) => (event, params) => {
    if (typeof windowInternal.CustomEvent === 'function') {
        return new windowInternal.CustomEvent(event, params);
    }
    const paramsToFunction = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = documentInternal.createEvent('CustomEvent');
    evt.initCustomEvent(event, paramsToFunction.bubbles, paramsToFunction.cancelable, paramsToFunction.detail);
    evt.prototype = windowInternal.Event.prototype;
    return evt;
};
exports.CreateEvent = CreateEvent;
const getHistory = (windowInternal, CreateEventInternal, generateKeyInternal) => {
    return {
        replaceState: (url, stateHistory) => {
            const key = generateKeyInternal();
            const state = stateHistory || windowInternal.history.state;
            windowInternal.history.replaceState({ key, state }, null, url);
            windowInternal.dispatchEvent(CreateEventInternal('popstate'));
        },
    };
};
const getCustomHistory = () => getHistory(window, (0, exports.CreateEvent)(window, document), generateKey);
exports.getCustomHistory = getCustomHistory;
//# sourceMappingURL=withRouter.js.map